module.exports = __webpack_public_path__ + "img/banner.b336f5df.webp";